/**
 * ResultData.ts
 */
export class ResultData {
    constructor() {
        this.reset();
    }
    reset() {
        this.noWin = true;
        this.lowWin = false;
        this.smallWin = false;
        this.bigWin = false;
        this.win2x = false;
        this.win25x = false;
        this.fullHouse = false;
        this.patternIndex = 0;
        this.matchedPatterns = [];
        this.slingoWin = null;
        this.jokerWin = null;
        this.coinWin = null;
    }
    setSlingoWin(value) {
        this.slingoWin = value;
    }
    setJokerWin(value) {
        this.jokerWin = value;
    }
    setCollectableWin(value) {
        this.collectableWin = value;
    }
    setCoinWin(value) {
        this.coinWin = value;
    }
    setNoWin(value) {
        this.noWin = value;
    }
    setWin2x(value) {
        this.win2x = value;
    }
    setLowWin(value) {
        this.lowWin = value;
    }
    setSmallWin(value) {
        this.smallWin = value;
    }
    setBigWin(value) {
        this.bigWin = value;
    }
    setWin25x(value) {
        this.win25x = value;
    }
    setFullHouse(value) {
        this.fullHouse = value;
    }
    setMatchedPatterns(value) {
        this.matchedPatterns = value;
    }
    setSymbolWin(value) {
        this.symbolWin = value;
    }
    hasCollectableWin() {
        return this.collectableWin != null;
    }
    hasCoinWin() {
        return this.coinWin != null;
    }
    hasJokerWin() {
        return this.jokerWin != null;
    }
    hasSlingoWin() {
        return this.slingoWin > 0;
    }
    hasSymbolWin() {
        return this.symbolWin > 0;
    }
    getSymbolWin() {
        return this.symbolWin;
    }
    hasNoWin() {
        return this.noWin;
    }
    hasWin2x() {
        return this.win2x;
    }
    isLowWin() {
        return this.lowWin;
    }
    isSmallWin() {
        return this.smallWin;
    }
    isBigWin() {
        return this.bigWin;
    }
    hasWin25x() {
        return this.win25x;
    }
    isFullHouse() {
        return this.fullHouse;
    }
    getCollectableWin() {
        return this.collectableWin;
    }
    getCoinWin() {
        return this.coinWin;
    }
    getJokerWin() {
        return this.jokerWin;
    }
    getSlingoWin() {
        return this.slingoWin;
    }
    hasNextPattern() {
        return this.patternIndex + 1 < this.matchedPatterns.length;
    }
    nextPattern() {
        this.patternIndex++;
    }
    getCurrentPattern() {
        return this.matchedPatterns[this.patternIndex];
    }
}
//# sourceMappingURL=ResultData.js.map